export default __webpack_public_path__ + "static/media/italy.1a047ead.webp";